import { render, staticRenderFns } from "./alignment.vue?vue&type=template&id=9dc986dc&"
import script from "./alignment.vue?vue&type=script&lang=js&"
export * from "./alignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports